import { convertDate } from 'utils/dateFormatter';
import { encodingUrl, removeTodasMascaras } from 'utils/stringFormatter';
import { converterAtivoFiltro } from 'utils/formUtils';
import { ENUM_TIPO_RELATORIO } from 'utils/consts';

export const _formatterArrayFilter = (name = '', filtro = []) => {
  if (filtro?.length === 0) return null;
  let parameters = '';
  filtro.forEach(x => (parameters += `&${name}=${x}`));
  return parameters.replace(`&${name}=`, '');
};

export const formatterFiltroRelatoriosFrontToBack = (
  data,
  tipoRelatorio,
  todosTipoPeriodo,
  isPesquisaAtendenteSetorial
) => {
  const filtro = {
    TipoPeriodo: todosTipoPeriodo?.find(x => x?.value === data?.tipoPeriodo)?.type,
    DataInicio: convertDate(data?.dataPesquisa?.dataInicio),
    DataFim: convertDate(data?.dataPesquisa?.dataFim),
    TipoRelatorio: tipoRelatorio,
    AssuntoId: data?.assunto,
    SolicitacaoId: _formatterArrayFilter('SolicitacaoId', data?.servico),
    AtendentesId: data?.atendente && _formatterArrayFilter('AtendentesId', data?.atendente),
    SetorId: data?.setor,
  };
  if (tipoRelatorio === ENUM_TIPO_RELATORIO.ATENDIMENTOS && isPesquisaAtendenteSetorial) {
    // SE A PESQUISA FOR PERFORMANCE SETORIAL, NÃO DEVE ENVIAR O SETOR;
    delete filtro.SetorId;
  }
  return filtro;
};

export const formatterFiltroSetorFrontToBack = dadosInputs => {
  return {
    nome: encodingUrl(dadosInputs?.nomeSetor),
    ativo: converterAtivoFiltro(dadosInputs?.ativo),
  };
};

export const formatterFiltroServicoSistemaFrontToBack = dadosInputs => {
  return {
    nome: encodingUrl(dadosInputs?.nomeServico),
    ativo: converterAtivoFiltro(dadosInputs?.ativo),
  };
};

export const formatterFiltroDuvidaServicoFrontToBack = data => {
  return {
    DataAberturaInicio: convertDate(data?.dataAbertura?.dataInicio),
    DataAberturaFim: convertDate(data?.dataAbertura?.dataFim),
    DataEncerramentoInicio: convertDate(data?.dataEncerramento?.dataInicio),
    DataEncerramentoFim: convertDate(data?.dataEncerramento?.dataFim),
    protocolo: encodingUrl(data?.protocolo),
    atendenteId: data?.atendenteId,
    assuntoId: data?.assuntoId,
    statusId: data?.statusId,
    tipoPessoaId: data?.tipoPessoaId,
    solicitacaoId: data?.solicitacaoId,
    SetorIds: _formatterArrayFilter('SetorIds', data?.setorId),
    numeroDocumento: removeTodasMascaras(data?.numeroDocumento),
  };
};

export const formatterFiltroRelatorioListaRequerimentosFrontToBack = data => {
  return {
    DataAberturaInicio: convertDate(data?.dataAbertura?.dataInicio),
    DataAberturaFim: convertDate(data?.dataAbertura?.dataFim),
    DataEncerramentoInicio: convertDate(data?.dataEncerramento?.dataInicio),
    DataEncerramentoFim: convertDate(data?.dataEncerramento?.dataFim),
    protocolo: encodingUrl(data?.protocolo),
    StatusId: data?.statusId,
  };
};

export const formatterFiltroAtendenteFrontToBack = dadosInputs => {
  return {
    atendente: dadosInputs.atendente,
    cargoId: dadosInputs?.cargoId,
    situacaoId: dadosInputs?.situacaoId,
    condicaoId: dadosInputs?.condicaoId,
  };
};
